module.exports = __webpack_public_path__ + "img/logo.6fb1734b.svg";